// Messages for portal/Dashboard (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.dashboard.head': 'Dashboard — Portal',
  'portal.dashboard.greeting': 'Hi {name} 👋',
  'portal.dashboard.greeting_generic': 'Welcome 👋',
  'portal.dashboard.tracking_one': 'Tracking {count} shipment',
  'portal.dashboard.tracking_other': 'Tracking {count} shipments',
  'portal.dashboard.tracking_for': ' for {company}.',
  'portal.dashboard.tracking_end': '.',
  'portal.dashboard.tile.active': 'Active shipments',
  'portal.dashboard.tile.in_transit': 'In transit',
  'portal.dashboard.tile.arriving_week': 'Arriving this week',
  'portal.dashboard.your_shipments': 'Your shipments',
  'portal.dashboard.view_all': 'View all',
  'portal.dashboard.empty': 'No shipments yet.',
}

export const zhTW = {
  'portal.dashboard.head': '儀表板 — 客戶入口',
  'portal.dashboard.greeting': '您好，{name} 👋',
  'portal.dashboard.greeting_generic': '歡迎 👋',
  'portal.dashboard.tracking_one': '追蹤 {count} 筆貨件',
  'portal.dashboard.tracking_other': '追蹤 {count} 筆貨件',
  'portal.dashboard.tracking_for': '，{company}。',
  'portal.dashboard.tracking_end': '。',
  'portal.dashboard.tile.active': '進行中貨件',
  'portal.dashboard.tile.in_transit': '運送中',
  'portal.dashboard.tile.arriving_week': '本週到達',
  'portal.dashboard.your_shipments': '您的貨件',
  'portal.dashboard.view_all': '查看全部',
  'portal.dashboard.empty': '尚無貨件。',
}
